module.exports = __webpack_public_path__ + "static/media/ticketVocation.2878f69b.svg";